export enum PermissionResourceName {
  Employee = 'Сотрудники',
  Project = 'Проекты',
  Role = 'Роли',
  Stats = 'Статистика',
  Test = 'Интерактивы',
  Organization = 'Организации',
  Theme = 'Темы',
}
